import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReviewPolicy = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "reviewPolicy",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17255",
		"data-name": "Group 17255",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12816",
				"data-name": "Path 12816",
				d: "M8,4,9.3,2.375A1,1,0,0,1,10.081,2H13.92a1,1,0,0,1,.781.375L16,4h0V5a1,1,0,0,1-1,1H9A1,1,0,0,1,8,5V4Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12817",
				"data-name": "Path 12817",
				d: "M9.667,9.333,8,11,7,10",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12818",
				"data-name": "Path 12818",
				d: "M13,18h3",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12819",
				"data-name": "Path 12819",
				d: "M13,10h3",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12820",
				"data-name": "Path 12820",
				d: "M9.667,13.333,8,15,7,14",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12821",
				"data-name": "Path 12821",
				d: "M13,14h3",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12822",
				"data-name": "Path 12822",
				d: "M16,4h2a2,2,0,0,1,2,2V20a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V6A2,2,0,0,1,6,4H8",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12823",
		"data-name": "Path 12823",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgReviewPolicy;
